import { getPushpinColor } from '@/lib/polaroid-utils';

interface PushpinProps {
  eventId: string;
}

export function Pushpin({ eventId }: PushpinProps) {
  const color = getPushpinColor(eventId);

  return (
    <div
      className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-[6px] z-10"
    >
      {/* Pin head */}
      <div
        className="w-4 h-4 rounded-full shadow-md relative"
        style={{ backgroundColor: color }}
      >
        {/* Highlight */}
        <div className="absolute top-[2px] left-[2px] w-[6px] h-[6px] rounded-full bg-white/40" />
      </div>
      {/* Pin shadow */}
      <div
        className="absolute top-[14px] left-1/2 -translate-x-1/2 w-2 h-1 rounded-full bg-black/10 blur-[1px]"
      />
    </div>
  );
}
